import { DependencyList, useCallback, useRef, useEffect } from "react";

export default function useInfiniteScroll<T extends HTMLElement>(
  callback: () => void,
  depls: DependencyList
) {
  const observer = useRef<IntersectionObserver | null>(null);

  const method = useCallback((node: T) => {
    if (observer.current) {
      observer.current.disconnect();
    }

    if (depls.every(Boolean)) {
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          callback();
        }
      });

      if (node) {
        observer.current.observe(node);
      }
    }
  }, depls);

  useEffect(() => {
    return () => {
      observer.current?.disconnect();
    };
  }, []);

  return method;
}
